export function buildAmendsReferenceId({ id: draftId, reviewCycle = 1 } = {}) {
    return `${draftId}!${reviewCycle}`
}
